import { usePlatformNotifications } from "@/hooks/usePlatformNotifications";
import { useCommonTranslation } from "@/services/culture/common.translations";
import { IconButton, Popover } from "@vintecc/components";
import { faBell } from "@vintecc/pro-light-svg-icons/faBell";
import { PlatformNotificationsList } from "./PlatformNotificationsList";
import { usePlatformNotificationsStore } from "@/store/platformNotificationsStore";

export const PlatformNotifications = () => {
  usePlatformNotifications();
  const { t } = useCommonTranslation();
  const hasUnread = usePlatformNotificationsStore((s) => s.hasUnread);

  return (
    <Popover allowedPlacements={["bottom"]} content={(setIsOpen) => <PlatformNotificationsList onClose={() => setIsOpen(false)} />}>
      <span className="relative">
        <IconButton
          iconName={faBell}
          aria-label={t("topbar.notifications")}
          type="button"
          naked
          style={{ "--theme-default-color": "var(--color-grey-400)" }}
          testId="topbar-notifications-button"
        />
        {hasUnread && <span className="absolute top-2 inset-e-2 w-2 h-2 bg-red-500 rounded-full" />}
      </span>
    </Popover>
  );
};
